import { render, staticRenderFns } from "./InboxMultipleOutline.vue?vue&type=template&id=4041f10b"
import script from "./InboxMultipleOutline.vue?vue&type=script&lang=js"
export * from "./InboxMultipleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports